module.exports = __webpack_public_path__ + "img/lk-mode-mobile-green.98b81ae6.svg";